/**
 * Verifica se o conteúdo tem blocos significativos (diferentes de 'title')
 * @param blocks - Objeto de blocos do Volto
 * @param blocksLayout - Layout dos blocos
 * @returns true se há blocos diferentes de 'title'
 */
export const hasSignificantBlocks = (
  blocks?: Record<string, unknown>,
  blocksLayout?: { items?: string[] },
): boolean => {
  const items = blocksLayout?.items || [];

  if (items.length === 0) {
    return false;
  }

  const hasNonTitleBlock = items.some(
    (id) => blocks?.[id]?.['@type'] !== 'title',
  );

  return hasNonTitleBlock;
};

export default hasSignificantBlocks;
